// Native
import {Box, Carousel, IconButton, Image} from "@chakra-ui/react"
import {LuChevronLeft, LuChevronRight} from "react-icons/lu"

// Custom
import {Parts, UI} from "components"

const images = [
    "1.jpeg",
    "2.jpeg",
    "3.jpeg",
]

export default function BestReferralCarousel(props) {
    return (
        <UI.Box {...props}>
            <Carousel.Root
                slideCount={images.length}
                maxW="100%"
                loop
                autoplay={{
                    delay: 3000,
                    pauseOnInteraction: false,
                    pauseOnHover: false
                }}
                allowMouseDrag
                transitionDuration="500ms"
            >
                {/*<Carousel.ItemGroup>*/}
                {/*    {images.map((img, index) => (*/}
                {/*        <Carousel.Item key={index} index={index}>*/}
                {/*            <Box w="100%" rounded="lg" overflow="hidden">*/}
                {/*                <Image*/}
                {/*                    src={img}*/}
                {/*                    w="100%"*/}
                {/*                    h="100%"*/}
                {/*                    objectFit="cover"*/}
                {/*                    alt={`Imagem ${index + 1}`}*/}
                {/*                />*/}
                {/*            </Box>*/}
                {/*        </Carousel.Item>*/}
                {/*    ))}*/}
                {/*</Carousel.ItemGroup>*/}

                {/*<Carousel.Control justifyContent="center">*/}
                {/*    <Carousel.PrevTrigger asChild>*/}
                {/*        <IconButton size="xs" variant="ghost">*/}
                {/*            <LuChevronLeft/>*/}
                {/*        </IconButton>*/}
                {/*    </Carousel.PrevTrigger>*/}

                {/*    <Carousel.Indicators/>*/}

                {/*    <Carousel.NextTrigger asChild>*/}
                {/*        <IconButton size="xs" variant="ghost">*/}
                {/*            <LuChevronRight/>*/}
                {/*        </IconButton>*/}
                {/*    </Carousel.NextTrigger>*/}
                {/*</Carousel.Control>*/}

                <Parts.Widgets.Ads image_url="comunicado_forma_pagamentos.jpeg" clickable={false}/>
                <Parts.Widgets.Ads image_url="preco-posicionamento.jpeg" clickable={false}/>
            </Carousel.Root>
        </UI.Box>
    )
}